<template class="feedback">
  <div>
    <main>
        <md-card v-bind:md-with-hover="puedeVerDetalles" v-if="showFluxer[0]">
            <md-card-header>
                <md-card-media>
                    <md-avatar>
                        <img :src="showFluxer[0].photoURL" alt="">
                    </md-avatar>
                </md-card-media>
                <md-card-header-text>
                    <div class="md-title">
                        {{showFluxer[0].displayName}}
                    </div>
                    <div class="md-subhead">
                        <div >
                          <p v-if="!feedback.isEspontaneo">{{texto}}</p>
                          <p v-if="feedback.isEspontaneo">Feedback espontaneo</p>
                        </div>
                    </div>
                </md-card-header-text>
            </md-card-header>
            <md-card-header class="footer">
                <md-card-area :md-inset="true">
                    <md-layout md-gutter>
                        <md-layout>
                            <span v-if="feedback.thanked" v-bind:title="tituloAgradecido">
                                <md-icon>thumb_up</md-icon>
                            </span>
                        </md-layout>
                        <md-layout v-if="feedback.completed">
                            <span>{{feedback.completed | moment("DD/MM/YYYY")}}</span>
                        </md-layout>
                    </md-layout>
                </md-card-area>
            </md-card-header>
        </md-card>
    </main>
  </div>
</template>


<script>
import FluxerService from '../services/fluxer'

export default {
  name: 'feedback',
  props: ['feedback', 'fluxer', 'texto'],
  data () {
    return {
      currentUser: FluxerService.getCurrentUser()
    }
  },
  computed: {
    puedeVerDetalles: function () {
      return Boolean(this.feedback) && Boolean(this.feedback.completed || this.feedback.editor === this.currentUser.email)
    },
    tituloAgradecido: function () {
      return this.$moment(this.feedback.thanked).format('DD/MM/YYYY')
    }
  },
  firebase: function () {
    return {
      showFluxer: {
        source: FluxerService.getFluxerByEmail(this.fluxer)
      }
    }
  },
  methods: {
    openConfirm (ref) {
      this.$refs[ref].open()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-card .md-card-media img {
        border: solid lightgrey;
        border-radius: 100%;
    }

    .md-card {
        min-width: 328px;
    }

    .md-avatar {
        width: 80px;
        min-width: 80px;
        height: 80px;
        min-height: 80px;
        border-radius: 100%;
    }

    .md-card-media {
        margin-left: 0px !important;
    }

    .md-card .md-card-header .md-card-header-text {
        margin-left: 20px;
        text-align: left;
    }

   .md-sidenav .md-sidenav-content {
        width: 50% !important;
    }

    .question {
        white-space: inherit !important;
    }

    .input-container {
        margin-top: -10px;
    }

    .container-buttons {
        padding: 30px 0;
    }

    .close-feedback {
        right: 0;
        position: absolute;
    }

    .feedback {
        overflow-x: hidden;
        margin: 10px 0;
    }

    .footer {
         text-align:right;
         color: grey;
         padding-top: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// Feedback.vue?8ac43b5c